import { Course } from "@/models/Product";

export const coursesMock: Course[] = [
  {
    id: "cr-1",
    title: "Curs PPL – Private Pilot License",
    description: "Curs complet pentru obținerea licenței de pilot privat. Include teorie și ore de zbor cu instructor.",
    price: 12000,
    images: ["https://images.unsplash.com/photo-1474302770737-173ee21bab63?w=800"],
    category: "courses",
    subcategory: "PPL",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-01-01",
    location: "București, România",
    status: "available",
    courseType: "PPL (Private Pilot License)",
    duration: "6-12 luni",
    provider: "Romanian Flight Academy",
  },
  {
    id: "cr-2",
    title: "Curs ULM – Licență Pilot Ultraușor",
    description: "Obține licența de pilot ultraușor. Zbor pe avioane ULM cu instructor certificat.",
    price: 5500,
    images: ["https://images.unsplash.com/photo-1540962351504-03099e0a754b?w=800"],
    category: "courses",
    subcategory: "ULM",
    sellerId: "s2",
    sellerName: "EuroAvion SRL",
    createdAt: "2025-12-01",
    location: "Cluj-Napoca, România",
    status: "available",
    courseType: "ULM",
    duration: "3-6 luni",
    provider: "Sky School Cluj",
  },
  {
    id: "cr-3",
    title: "Curs Parașutism AFF",
    description: "Curs de parașutism Accelerated Free Fall. De la primul salt la salt solo.",
    price: 3500,
    images: ["https://images.unsplash.com/photo-1521673461164-de300ebcfb17?w=800"],
    category: "courses",
    subcategory: "Cursuri parasutism",
    sellerId: "s3",
    sellerName: "RotorWing Romania",
    createdAt: "2025-11-10",
    location: "Brașov, România",
    status: "available",
    courseType: "Cursuri parasutism",
    duration: "2-4 luni",
    provider: "SkyDive Brașov",
  },
  {
    id: "cr-4",
    title: "Curs CPL – Commercial Pilot License",
    description: "Program avansat pentru obținerea licenței de pilot comercial. Include ME/IR rating.",
    price: 45000,
    images: ["https://images.unsplash.com/photo-1559628233-100c798642d4?w=800"],
    category: "courses",
    subcategory: "CPL",
    sellerId: "s1",
    sellerName: "SkyTraders Aviation",
    createdAt: "2026-02-10",
    location: "București, România",
    status: "available",
    courseType: "CPL (Commercial Pilot License)",
    duration: "12-18 luni",
    provider: "Romanian Flight Academy",
  },
];
